import { BaseEntity, DefaultResponseWithData } from "../system";
import { IPart } from './../Part';

export interface GetEbayListingBatchItems extends DefaultResponseWithData<IEbayListingBatchItem[]> { }

export interface IEbayListingBatch extends BaseEntity {
  isComplete: boolean;
  batchItems: IEbayListingBatchItem[];
}

export interface IEbayListingBatchItem extends BaseEntity {
  isListed: boolean;
  isCancelled: boolean;
  isProcessing: boolean;
  isAutomated: boolean;
  type: BatchItemType;
  errorMessage: string;

  /** eBay rejected this item as a prohibited/restricted item — it can never be listed. */
  isRestricted: boolean;
  /** eBay's prohibited-item rule code, e.g. "PI_HAZ_AirbagCovers". Null if eBay gave no code. */
  restrictedCode: string | null;
  restrictedReason: string | null;

  partDataId: string;
  partData: IPart;
  ebayListingBatchId: string;
  ebayListingBatch: IEbayListingBatch;
}

export interface BulkListingStatsResponse {
  all: number;
  manual: number;
  automated: number;
  relisted: number;
  failed: number;
  restricted: number;
  errorCount: { [key: string]: number };
  restrictedCount: { [key: string]: number };
}

export enum BatchItemType {
  Manual,
  Automated,
  Relisted
}